import { events } from "@planzone/events";
import { Boundaries } from "@planzone/core";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleEditTimeRecordsListingConfigurationRequest(
  state: State,
  { planzone }: Boundaries["editTimeRecordsListingConfiguration"]["request"],
): State {
  const index = state.findIndex((req) => req.planzone.uuid === planzone.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { ...state[index], request: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [...state, { planzone, request: setRequestStateToPending() }];
}

function handleEditTimeRecordsListingConfigurationSuccess(
  state: State,
  { planzone }: Boundaries["editTimeRecordsListingConfiguration"]["success"],
): State {
  const index = state.findIndex((req) => req.planzone.uuid === planzone.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { ...state[index], request: setRequestStateToSuccess() },
        ...state.slice(index + 1),
      ]
    : [...state, { planzone, request: setRequestStateToSuccess() }];
}

function handleEditTimeRecordsListingConfigurationFailure(
  state: State,
  { planzone }: Boundaries["editTimeRecordsListingConfiguration"]["failure"],
): State {
  const index = state.findIndex((req) => req.planzone.uuid === planzone.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { ...state[index], request: setRequestStateToFailure() },
        ...state.slice(index + 1),
      ]
    : [...state, { planzone, request: setRequestStateToFailure() }];
}

const reduceState = createStateReducer(initialState, {
  [events.editTimeRecordsListingConfigurationRequested]:
    handleEditTimeRecordsListingConfigurationRequest,
  [events.editTimeRecordsListingConfigurationSucceeded]:
    handleEditTimeRecordsListingConfigurationSuccess,
  [events.editTimeRecordsListingConfigurationFailed]:
    handleEditTimeRecordsListingConfigurationFailure,
});

export type { State, Selector };

export { reduceState, initialState, createSelector };
